var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinnesota(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.048,71.273c0,0-0.93-4.955-3.718-4.647c-2.789,0.31-11.155,9.296-16.112,8.986 c-4.96-0.311-32.223-15.492-36.252-17.352c-4.03-1.859-13.942-6.197-13.942-6.197l-4.958,6.197c0,0-28.814-5.577-33.773-7.745 c-4.957-2.169-7.126-25.097-7.126-25.097l-6.817-2.17v16.731H36.41l3.717,10.226V77.16l4.648,14.873l3.718,47.87l4.184,8.831v16.269 v6.04l-6.972,6.973l13.014,11.153v59.113v16.644l113.539-1.82l41.072-0.658c0,0-0.929-13.324-2.173-15.802 c-1.238-2.48-15.799-11.154-15.799-11.154l-7.437-11.465h-7.438l-1.547-4.338l-6.818-1.548l-6.195-5.888l-1.24-20.141 c0,0,3.717-5.266,4.029-7.126c0.311-1.858-7.128-9.915-7.128-9.915l4.647-10.068l10.226-8.212l1.239-23.548 c0,0,4.558-3.065,3.693-4.41c0,0,0-0.001,0-0.002c-2.585-4.032,6.533-5.813,10.249-8.292c3.719-2.479,18.901-24.478,21.38-26.337 c2.478-1.858,4.336-5.886,19.831-10.535c15.491-4.647,17.659-9.913,17.659-9.913C238.117,73.753,217.048,71.273,217.048,71.273z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinnesota);
export default __webpack_public_path__ + "static/media/minnesota.1123b2a4c3d4d9f9aaf9cd7aae47e943.svg";
export { ForwardRef as ReactComponent };